export const SIDEBAR_ID = 'sidebar';
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@9.12.4 (a02ac1bd0)
